// src/services/companyConfigService.js
import axios from "axios";
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL_PROD // https://demenagementsamyyhaul.ca/api
    : process.env.REACT_APP_API_URL_DEV; // http://158.69.205.231:3000

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const companyConfigService = {
  // Récupérer la dernière configuration
  getLatestConfig: async () => {
    try {
      const response = await api.get("/company-config/latest");
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de la configuration:",
        error
      );
      throw error;
    }
  },

  // Mettre à jour une configuration existante
  updateConfig: async (id, configData) => {
    try {
      const response = await api.patch(`/company-config/${id}`, configData);
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la mise à jour de la configuration:",
        error
      );
      throw error;
    }
  },

  // Créer une nouvelle configuration
  createConfig: async (configData) => {
    try {
      const response = await api.post("/company-config", configData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création de la configuration:", error);
      throw error;
    }
  },

  // Télécharger un logo
  getLogo: async () => {
    try {
      const response = await api.get("/company-config/logo");
      return response.data; // { logo: 'https://example.com/logo.png' }
    } catch (error) {
      console.error("Erreur lors de la récupération du logo :", error);
      throw error;
    }
  },
};
export default companyConfigService;
